import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";
// import form1 from '';
// import form2 from '../../pages/Finddealercontact';
// import form3 from '../../pages/Saleconstct';
// import form4 from '../../pages/Dealershipcontact';
// import form5 from '../../pages/Exportconatct';
// import form6 from '../../pages/Sparesserviceconatct';
// import form7 from '../../pages/careeratconatct';

const enquiryTypes = [
  {
    formlink: "GET IN TOUCH",
    name: "GENERAL ENQUIRY",
    path: "../general-enqiure",
  },
  // { formlink: "GET IN TOUCH", name: "FIND YOUR DEALER", path: "../find-dealer" },
  { formlink: "GET IN TOUCH", name: "SALES ENQUIRY", path: "../sales-enquiry" },
  {
    formlink: "GET IN TOUCH",
    name: "DEALERSHIP ENQUIRY",
    path: "../dealership-enquiry",
  },
  // { formlink: "GET IN TOUCH", name: "EXPORT ENQUIRY", path: "../export-enquiry" },
  {
    formlink: "GET IN TOUCH",
    name: "SPARES & SERVICE REQUEST",
    path: "../servicespare",
  },
  {
    formlink: "GET IN TOUCH",
    name: "CAREER AT DASMESH",
    path: "../career-das",
  },
];
console.log(enquiryTypes);

const reachus = () => {
  window.scrollTo(0, 0);
};

// const handleChange = (e) => {
//   const { name, value, type, checked } = e.target;

//   setFormData({
//     ...formData,
//     [name]: type === "checkbox" ? checked : value,
//   });
// };

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    message: "",
    requirement: "",
    consent: false,
  });
  // const [formData, setFormData] = useState(defaultFormData);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone") {
      // Only allow numeric values for phone
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      console.log("Selected file:", e.target.files[0]);
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader on form submit
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("address", formData.address);
    formDataToSend.append("city", formData.city);
    formDataToSend.append("country", formData.country);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("requirement", formData.requirement);

    if (file) {
      formDataToSend.append("attachments", file); // Ensure "attachments" matches the multer field
    }

    try {
      const response = await fetch("https://dasmesh-mailer.ritaz.in/career-send-email", {
        method: "POST",
        body: formDataToSend,
      });

      //   console.log("Response:", formData.currentPost);

      if (response.ok) {
        // alert("Email sent successfully!");
        toast.success("Email sent successfully!"); // Success toast
        setFormData({}); // Reset form data
        resetForm(); // Call reset function after success
      } else {
        // alert("Error sending email!");
        toast.error("Error sending email!"); // Error toast
      }
    } catch (error) {
      //   alert("Error sending email!");
      toast.error("Error sending email!"); // Error toast
    } finally {
      setLoading(false); // Hide loader after submission
    }
  };

  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
    message: "",
    requirement: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData); // Reset all fields to their initial state
  };

  return (
    <div className="hmsection9-contact">
      <div className="contact-form-address">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="contact-box-name">
              <h5>CORPORATE OFFICE</h5>
              <div className="contact-box">
                <p>
                  Dasmesh Mechanical Works Pvt. Ltd.
                  <br />
                  Dasmesh Agricultural Industries Pvt. Ltd.
                </p>
                <span>
                  {" "}
                  <i className="fa-solid fa-location-dot"></i> Raikot Rd,
                  Malerkotla-148023, INDIA
                </span>
                <br />
                <span>
                  <i className="fa-solid fa-phone"></i> +91 8872688726
                </span>
                <br />
                <span>
                  {" "}
                  <i className="fa-solid fa-envelope"></i>
                  <a href="mailto:info@dasmesh.com"> sales@dasmesh.com</a>
                </span>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-1 col-md-12"></div> */}
          <div className="col-lg-12 col-md-12 mt-3">
            <div className="contact-box-name" id="contact-box-2">
              <h5>IMPORTANT CONTACTS</h5>
              <div className="contact-box">
                <div className="contact-box-inner-divide">
                  <div>
                    <p>
                      <strong>Domestic Sales & Support</strong>
                    </p>
                    <span>
                      <i className="fa-solid fa-phone"></i> Sales: +91 8872688726
                    </span>
                    <br />
                    {/* <span><i class="fa-solid fa-phone"></i> South East (India): +91 94170 55726</span><br /> */}
                    <span>
                      <i className="fa-solid fa-phone"></i> Toll Free (India):
                      1800-5326-726
                    </span>
                    <br />
                    <span>
                      <i className="fa-solid fa-envelope"></i>{" "}
                      <a href="mailto:sales@dasmesh.com">sales@dasmesh.com</a>
                    </span>
                  </div>
                  <div>
                    <p>
                      <strong>OVERSEAS SALES & SUPPORT</strong>
                    </p>
                    <span>
                      <i className="fa-solid fa-phone"></i> Export: +91 9915260726
                    </span>
                    <br />
                    <span>
                      <i className="fa-solid fa-envelope"></i>{" "}
                      <a href="mailto:exports@dasmesh.com">
                        exports@dasmesh.com
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12"></div>
          <div className="col-lg-4 col-md-12"></div>
          <div className="col-lg-4 col-md-12">
            {/* <div className="contact-box-name">
                            <h5>PURCHASE SUPPORT</h5>
                            <div className="contact-box">
                                <span><i class="bi bi-telephone"></i> +91 8872688726</span>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
      <div className="contact-form-contact">
        <div>
          <h3>Get in Touch</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name"
              required
            />
            <br />
            <div className="row">
              <div className="col-lg-6 col-12">
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="city"
                  required
                />
              </div>
              <div className="col-lg-6 col-12">
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  placeholder="country"
                  required
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-lg-6 col-12">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                />
              </div>
              <div className="col-lg-6 col-12">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  required
                  inputMode="numeric"
                />
              </div>
            </div>
            <br />
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Address"
            />
            <br />
            <select
              name="requirement"
              value={formData.requirement}
              onChange={handleChange}
              required
            >
              <option value="">Select Requirement</option>
              <option value="GENERAL ENQUIRY">GENERAL ENQUIRY</option>
              <option value="DEALERSHIP ENQUIRY">DEALERSHIP ENQUIRY</option>
              <option value="SALES ENQUIRY">SALES ENQUIRY</option>
              <option value="SPARES & SERVICE REQUEST">
                SPARES & SERVICE REQUEST
              </option>
              <option value="CAREER AT DASMESH">CAREER AT DASMESH</option>
            </select>

            {(formData.requirement === "DEALERSHIP ENQUIRY" ||
              formData.requirement === "CAREER AT DASMESH") && (
              <div className="file-upload-container">
                <div className="file-name-display">
                  {fileName || "Attach File"}
                </div>
                <label htmlFor="file-upload" className="file-upload-button">
                  Choose File
                </label>
                <input
                  id="attachments1"
                  type="file"
                  name="attachments"
                  onChange={handleFileChange}
                  className="file-input"
                  multiple
                />
              </div>
            )}

            <br />
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Message"
            ></textarea>
            <br />
            <div className="contact-checkbox-form">
              <input
                type="checkbox"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
              />
              <p>
                By checking this box, you consent and agree to DASMESH sending
                text messages or placing voice calls (live or pre-recorded).
              </p>
            </div>

            {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Email"}
            </button>
          </form>
          {/* Toast container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
          />
        </div>
      </div>
      <div className="enquiry-buttons-contact" style={{ display: "none" }}>
        {enquiryTypes.map((type) => (
          <div key={type.name} className="enqire-innr-sec">
            <h4>{type.name}</h4>
            <Link
              to={type.path}
              className="enquiry-button-contact"
              onClick={reachus}
            >
              {type.formlink}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
